import { isEqual, isFunction } from "lodash-es";
import { Dispatch, SetStateAction, useCallback } from "react";
import {
  FieldError,
  FieldName,
  FieldPathValue,
  FieldValues,
  get,
  Path,
  SetValueConfig,
  UseFormReturn,
} from "react-hook-form";

export const getFieldError = (errors: object, name: string) =>
  get(errors, name) as FieldError | undefined;

export const setFormValueIfChanged = <T extends object>(
  form: UseFormReturn<T>,
  name: Path<T>,
  value: FieldPathValue<FieldValues, FieldName<T>>,
  options?: SetValueConfig,
) => {
  if (!isEqual(form.getValues(name), value)) {
    form.setValue(name, value, options);
  }
};

export const useFormStateDispatch = <T extends object>(
  form: UseFormReturn<T>,
  name: Path<T>,
): Dispatch<SetStateAction<FieldPathValue<FieldValues, FieldName<T>>>> =>
  useCallback(
    (value: SetStateAction<unknown>) => {
      const oldValue = form.getValues(name);
      const newValue = isFunction(value) ? value(oldValue) : value;
      setFormValueIfChanged(form, name, newValue, { shouldDirty: true });
    },
    [form, name],
  );
